exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".userInfo-4f91a{margin-bottom:8px;cursor:pointer;color:#595959}.avatar-23c6d{margin-right:6px}", ""]);

// Exports
exports.locals = {
	"userInfo": "userInfo-4f91a",
	"avatar": "avatar-23c6d"
};